import React, { useState, useEffect } from "react";
import { Select, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { getList } from "services/api/Api";
import IntlMessages from "@util/IntlMessages";
import { injectIntl, useIntl } from "react-intl";
import { isActivePublicUser } from "../../../../util/Scripts";
import { Message, Switch, Button, Input } from "../../../BP2Components";
const { Option } = Select;

const AdvancedSearchSettings = ({ value }) => {
   const dispatch = useDispatch();
   const [options, setOptions] = useState();

   const [listWidgets, setListWidgets] = useState();
   const [dataSource, setDataSource] = useState();
   const { currentBoard, sheet } = useSelector(({ boards }) => boards);

   const [settings, setSettings] = useState({
      ...value
   });

   const intl = useIntl();

   const columns = [
      {
         title: <IntlMessages id="settings.label" />,
         dataIndex: "label",
         key: "label"
      },
      {
         title: <IntlMessages id="settings.createSearchInput" />,
         dataIndex: "operation",
         render: (text, record) =>
            dataSource.length >= 1 ? (
               <>
                  <Switch
                     onChange={(e) => handleSwitch(e, record.key)}
                     defaultChecked={record.checked}
                  />
               </>
            ) : null
      }
   ];
   useEffect(() => {
      var listOfLists;
      currentBoard.sheets.forEach((currentBoardheet) => {
         if (currentBoardheet.id === sheet) {
            listOfLists = currentBoardheet.widgets.filter((widget) => {
               return widget.name === "list";
            });
         }
      });

      const listOfId = listOfLists.map((widget) => widget.id);
      setListWidgets(listOfLists);
      setOptions(listOfId);
      if (settings.selectedWidgetId !== undefined) {
         setDataSource(value.searchInput);
      }
   }, [currentBoard.sheets, value.searchInput, settings.selectedWidgetId, sheet]);

   const handleSwitch = (checked, key) => {
      dataSource.filter((item) => {
         if (item.key === key) {
            item.checked = checked;
         }
         return null;
      });
      setSettings({ ...settings, searchInput: dataSource });
   };
   const handleSubmit = (e) => {
      e.preventDefault();
      setSettings({ ...settings, searchInput: dataSource });
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleSubmitSelect = (e) => {
      e.preventDefault();
      const list = listWidgets.filter((list) => {
         return list.id === settings.selectedWidgetId;
      });

      const columnCopy = [];

      const actualSerie = list[0].listWidgetSeries[0].listId;
      getList(actualSerie, 1, 10).then((res) => {
         const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
         responseData.columns.map((column, i) => {
            if (column.options.visible === 1) {
               columnCopy.push({
                  label: column.label,
                  checked: false,
                  key: i
               });
            }
            return null;
         });
         setDataSource(columnCopy);
         setSettings({ ...settings, searchInput: columnCopy });
      });
   };

   const handleSelect = (value) => {
      setSettings({ ...settings, selectedWidgetId: value });
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label key="title" className="widget-settings__inner__label">
                  <IntlMessages id="settings.title" />:
                     <Input
                        type="title"
                        name="title"
                        onChange={handleChange}
                        defaultValue={value.title}
                     />
                  </label>
               </div>
               <div>
                  <Button buttonType="primary" htmlType="submit">
                     <IntlMessages id="global.preview" />
                  </Button>
               </div>
            </div>
         </form>
         <form onSubmit={handleSubmitSelect}>
            <div className="widget-settings">
               <div>
                  <label key="widgetId" className="widget-settings__inner__label">
                  <IntlMessages id="settings.widgetId" />:
                     <Select
                        placeholder="select"
                        style={{ width: "100px" }}
                        defaultValue={value.selectedWidgetId}
                        onChange={handleSelect}
                     >
                        {options
                           ? options.map((option) => <Option value={option}>{option}</Option>)
                           : ""}
                     </Select>
                  </label>
               </div>
               <div className="gx-mt-0">
                  <Button buttonType="primary" htmlType="submit">
                     <IntlMessages id="settings.search" />
                  </Button>
               </div>
            </div>
         </form>
         <div>
            {dataSource && dataSource !== null ? (
               <Table size="small" dataSource={dataSource} columns={columns} />
            ) : (
               ""
            )}
         </div>
      </>
   );
};
export default injectIntl(AdvancedSearchSettings);
